import { MarkerBaseState } from 'markerjs2';

export class ChartAnnotations {

    indicators: any[];
    markerState: MarkerBaseState;

    constructor(
        indicators?: any[],
        markerState?: MarkerBaseState
    ) {
        this.indicators = indicators;
        this.markerState = markerState;
    }

    clone(): ChartAnnotations {
        return new ChartAnnotations(
            this.indicators ? structuredClone(this.indicators) : undefined,
            this.markerState ? JSON.parse(JSON.stringify(this.markerState)) : undefined
        );
    }

    isEqual(other: ChartAnnotations): boolean {
        return JSON.stringify(this.indicators) === JSON.stringify(other.indicators)
            && JSON.stringify(this.markerState) === JSON.stringify(other.markerState);
    }
}
